/* eslint-disable eqeqeq */
import React from 'react';
import { AppsType, getIsIosApp, getMoneyType, Pages, toAppMoney } from '../custom_views/insta_custom_views/utils_android/UtilsAndroid';

const ActiveTaskItem = ({ task, onTaskClicked, backView, isUpmob, isActive }) => {
    const isIos = getIsIosApp()
    const openTask = () => {
        // на iPhone все задания — iPhone (гарантированный отзыв или оценка/отзыв по скриншоту): своя страница
        onTaskClicked(task, (isIos || task.type_os == AppsType.ios ? Pages.task_ios : task.garanted_review_enable == 1 ? Pages.task_garanted_review : Pages.task), backView);
    };
    // console.log("active task props.task = ", task)
    return (
        <div>
            {task.dateTitle && <p style={{ marginLeft: '16px' }} className="task_name">{task.dateTitle}</p>}
            <div className="task_item_container hover" onClick={openTask}>
                <div className="flex task_item_full_width">
                    <img className="task_item_icon custom_icons_task_shadow" src={task.icon} alt="" />
                    <div className="block justify_content task_item_full_width">
                        <p className="task_item_title task_name_overflow">{task.name}</p>
                        {isActive ?
                        task.type_os != undefined ?
                        <p className="task_item_type">{task.type_os == AppsType.android ? "Задание в Google Play" : task.type_os == AppsType.ios ? "Задание в App Store" : "Задание в RuStore"}</p>
                        :
                        <p style={{color : '#2DB789'}} className="task_item_type">Активно</p>
                        : task.retentionMissed > 0 ?
                        // часть дней открытия пропущена — выполнять больше нечего, но и «Выполнено» было бы неправдой
                        <p style={{color : '#8C96A3'}} className="task_item_type">Завершено</p>
                        :
                        <p style={{color : '#2DB789'}} className="task_item_type">Выполнено</p>}
                        {/* <p className='task_item_price'>+{task.price_one_install_employer}₽</p> */}
                    </div>
                </div>
                {/* <p className="task_item_money_c">+{task.price_one_install_employer}₽</p> */}
                {/* {!isUpmob ?  */}
                    <div className="task_item_money_c flex">+{toAppMoney(task.price_one_install_employer)}<span>{getMoneyType(isUpmob)}</span></div>
                {/* :
                    <p className="task_item_money_c">+{formatMoney(task.price_one_install_employer)}₽</p>
                } */}
            </div>
       
        </div>
    );
};

export default ActiveTaskItem;